import React, { useEffect, useState } from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { LimitedDrops } from '../components/LimitedDrops';
import { WalkoutSection } from '../components/WalkoutSection';
import { FighterCollection } from '../components/FighterCollection';
import { CommunitySection } from '../components/CommunitySection';
import { NewsletterSection } from '../components/NewsletterSection';
import { CartSidebar } from '../components/CartSidebar';
import { Product } from '../components/FightCardProduct';
interface CartItem extends Product {
  quantity: number;
}
export function HomePage() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const addToCart = (product: Product) => {
    setCartItems(prev => {
      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        return prev.map(item => item.id === product.id ? {
          ...item,
          quantity: item.quantity + 1
        } : item);
      }
      return [...prev, {
        ...product,
        quantity: 1
      }];
    });
    setIsCartOpen(true);
  };
  const updateQuantity = (id: string, delta: number) => {
    setCartItems(prev => prev.map(item => {
      if (item.id === id) {
        const newQty = Math.max(0, item.quantity + delta);
        return {
          ...item,
          quantity: newQty
        };
      }
      return item;
    }).filter(item => item.quantity > 0));
  };
  const removeItem = (id: string) => {
    setCartItems(prev => prev.filter(item => item.id !== id));
  };
  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  // Scroll-following spotlight: moves down at 0.4x scroll speed
  const spotlightY = 300 + scrollY * 0.4;
  return <div className="min-h-screen bg-fight-black" style={{
    color: '#e0e0e0'
  }} data-id="element-207">
      {/* Scroll-following radial gradient spotlight */}
      <div className="fixed inset-0 pointer-events-none z-0" style={{
      background: `radial-gradient(ellipse 900px 700px at 50% ${spotlightY}px, rgba(245,230,20,0.022) 0%, transparent 65%)`
    }} data-id="element-208" />

      <Navigation cartCount={cartCount} onOpenCart={() => setIsCartOpen(true)} data-id="element-209" />

      <main className="relative z-10" data-id="element-210">
        <HeroSection data-id="element-211" />
        <FeaturedProducts onAddToCart={addToCart} data-id="element-212" />
        <LimitedDrops onAddToCart={addToCart} data-id="element-213" />
        <WalkoutSection onAddToCart={addToCart} data-id="element-214" />
        <FighterCollection onAddToCart={addToCart} data-id="element-215" />
        <CommunitySection data-id="element-216" />
        <NewsletterSection data-id="element-217" />
      </main>

      <footer className="bg-black py-12 text-center relative z-10" style={{
      borderTop: '1px solid rgba(255,255,255,0.05)'
    }} data-id="element-218">
        <img src="https://cdn.magicpatterns.com/uploads/igMiamPeru7PGzkV6cwrzL/logo_ohne-hintergrund-klein.png" alt="Zehners Merch" className="h-16 w-auto object-contain mx-auto mb-4" style={{
        filter: 'drop-shadow(0 0 20px rgba(245,230,20,0.2))'
      }} data-id="element-219" />
        <p className="font-barlow text-sm tracking-widest uppercase" style={{
        color: '#555'
      }} data-id="element-220">
          © 2024 ZEHNERS MERCH. ALL RIGHTS RESERVED. FIGHT WITH HONOR.
        </p>
      </footer>

      <CartSidebar isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} cartItems={cartItems} onUpdateQuantity={updateQuantity} onRemoveItem={removeItem} data-id="element-221" />
    </div>;
}